import ForkIcon from 'components/common/icons/ForkIcon'

const OrderAgainCarouselFiller = () => {
  return (
    <div className="flex h-full flex-col items-center justify-center space-y-6 text-center">
      <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-[#F0DAC9] text-[#CA4F0E]">
        <div className="h-6 w-6">
          <ForkIcon />
        </div>
      </div>
      <div className="space-y-2">
        <p className="text-k/20_110 font-semibold">
          Nothing more to reorder here… yet.
        </p>
        <p className="mx-auto max-w-[287px] text-k/16_125">
          Order more meals, rate and review, and we&apos;ll let you know when
          something else you love is available to reorder here.
        </p>
      </div>
    </div>
  )
}

export default OrderAgainCarouselFiller
